
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AdminMessage } from '@shared/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { BotService } from 'src/app/shared/services/bot.service';

@Component({
  selector: 'app-supervisor-message-modal',
  templateUrl: './supervisor-message-modal.component.html',
  imports: [FormsModule, ButtonModule, InputTextModule]
})
export class SupervisorMessageModalComponent {
  constructor(private botService: BotService, public bsModalRef: BsModalRef) { }
  public supervisorMessage!: AdminMessage;
  public botId!: string;

  public answerText = '';
  public async sendAnswerTosupervisor() {
    if (this.answerText.trim() === '') return;
    await this.botService.answerSupervisor(this.botId, this.supervisorMessage._id, this.answerText);
    this.bsModalRef.hide();
  }

  // @HostBinding('class') protected readonly class = 'contents'; // Makes component host as if it was not there, can offer less css headaches. Assumes .contents{display:contents} css class exits
  // constructor() {}

}

